module.exports = __webpack_public_path__ + "img/sj.e4bdc1d9.jpg";